import React, { useEffect, useState } from "react";
import BreathingPacer from "./BreathingPacer";

/**
 * ResponsivePacer — picks a sensible BreathingPacer size based on viewport
 * width. Phones get a smaller pulsing circle so it doesn't dominate the
 * screen or overlap controls; desktop sees the full-size visual.
 *
 * Sizes are passed in as { mobile, desktop } so each caller (Mode A vs
 * Mode B) can tune to its own layout.
 */
export default function ResponsivePacer({
  active = true,
  pattern = "4-4-6-2",
  onPhaseChange = null,
  sizes = { mobile: 160, desktop: 220 },
}) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 640 : false
  );

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const size = isMobile ? sizes.mobile : sizes.desktop;

  return (
    <BreathingPacer
      active={active}
      pattern={pattern}
      size={size}
      onPhaseChange={onPhaseChange}
    />
  );
}
